import api from '../instance/axios_instance.ts';
import { CustomerInterface } from '../interface/customerInterface.ts';

const CustomersApi = async (): Promise<CustomerInterface> => {

    try {
        const response = await api.get<CustomerInterface>('/customers');
        return response.data
    }
    catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
};

export default CustomersApi;